export function handleFileUpload() {
  const input = document.querySelector("#curriculo");
  const labelText = document.querySelector(".upload-text");
  if (input) {
    input.addEventListener("change", function () {
      if (input.files && input.files.length > 0) {
        labelText.textContent = input.files[0].name;
      } else {
        labelText.textContent = "Anexar currículo";
      }
    });
  }

  // MUDANDO A DIV DE TELEFONES PARA OUTRO LUGAR

  function moverTelefonesSeMobile() {
    var $telefonesContato = $(".suportePage .telefonesContato");
    var $form = $(".suportePage form.box");
    var $parentRow = $(".suportePage .row");

    if ($(window).width() <= 768) {
      if (!$telefonesContato.hasClass("foraDoForm")) {
        $telefonesContato.addClass("foraDoForm");
        $parentRow.append($telefonesContato);
      }
    } else {
      if ($telefonesContato.hasClass("foraDoForm")) {
        $telefonesContato.removeClass("foraDoForm");
        $form.find(".boxMain").append($telefonesContato);
      }
    }
  }

  moverTelefonesSeMobile();
  $(window).on("resize", function () {
    moverTelefonesSeMobile();
  });
}
